import React from 'react';

const TemplatePreview = ({ preview }) => {
  if (!preview || !preview.components) {
    return null;
  }

  const renderComponent = (component, index) => {
    if (!component) return null;

    // Header component
    if (component.type === 'HEADER') {
      if (component.format === 'IMAGE') {
        return (
          <div key={index} className="w-full h-32 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
            <div className="text-gray-500 text-sm">📷 Image</div>
          </div>
        );
      } else if (component.format === 'VIDEO') {
        return (
          <div key={index} className="w-full h-32 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
            <div className="text-gray-500 text-sm">🎥 Video</div>
          </div>
        );
      } else if (component.format === 'DOCUMENT') {
        return (
          <div key={index} className="w-full h-16 bg-gray-200 rounded-lg flex items-center justify-center mb-2">
            <div className="text-gray-500 text-sm">📄 Document</div>
          </div>
        );
      } else if (component.rendered_text || component.text) {
        return (
          <div key={index} className="mb-2">
            <div className="text-sm font-semibold text-gray-900">
              {component.rendered_text || component.text}
            </div>
          </div>
        );
      }
    }

    // Body component
    if (component.type === 'BODY') {
      return (
        <div key={index} className="mb-2">
          <div className="text-sm text-gray-800 whitespace-pre-wrap">
            {component.rendered_text || component.text || ''}
          </div>
        </div>
      );
    }

    // Footer component
    if (component.type === 'FOOTER') {
      return (
        <div key={index} className="mt-2">
          <div className="text-xs text-gray-500">
            {component.rendered_text || component.text || ''}
          </div>
        </div>
      );
    }

    // Buttons component
    if (component.type === 'BUTTONS' && component.buttons) {
      return (
        <div key={index} className="mt-3 space-y-2">
          {component.buttons.map((button, btnIdx) => {
            let buttonClass = 'w-full px-4 py-2 rounded text-sm font-medium text-center ';
            if (button.type === 'QUICK_REPLY') {
              buttonClass += 'bg-white border border-green-500 text-green-600 hover:bg-green-50';
            } else if (button.type === 'URL') {
              buttonClass += 'bg-blue-500 text-white hover:bg-blue-600';
            } else if (button.type === 'PHONE_NUMBER') {
              buttonClass += 'bg-green-500 text-white hover:bg-green-600';
            } else {
              buttonClass += 'bg-gray-200 text-gray-700 hover:bg-gray-300';
            }

            return (
              <button
                key={btnIdx}
                className={buttonClass}
                disabled
              >
                {button.text}
              </button>
            );
          })}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
      <div className="text-xs text-gray-500 mb-2 font-medium">TEMPLATE PREVIEW</div>

      {/* WhatsApp-like message bubble */}
      <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200 max-w-sm">
        {preview.components.map((component, index) => renderComponent(component, index))}
      </div>

      {/* Template metadata */}
      <div className="mt-3 text-xs text-gray-600">
        <div><strong>Template:</strong> {preview.template_name}</div>
        {preview.template_language && (
          <div><strong>Language:</strong> {preview.template_language}</div>
        )}
        {preview.template_category && (
          <div><strong>Category:</strong> {preview.template_category}</div>
        )}
      </div>
    </div>
  );
};

export default TemplatePreview;

